module.exports = __webpack_public_path__ + "c67809097ec632c7b3d001a159a72d51.png";